import { z } from "zod";
import {
  audienceMarketSchema,
  engineModeSchema,
  outputLanguageSchema,
  platformSchema,
} from "./coreSchemas";

export const composerMaterialSchema = z.object({
  materialId: z.string(),
  text: z.string().max(12_000),
  uploadId: z.string().nullable(),
  objectId: z.string().nullable().optional(),
  displayOrdinal: z.number().int().min(1).max(20).nullable().optional(),
  sellingPoint: z.string().max(500),
  creatorTier: z.string().max(40),
  fileName: z.string().nullable(),
  mime: z.string().nullable(),
  size: z.number().int().nonnegative().nullable(),
  analysisSummary: z.string().nullable(),
  uploadKey: z.string().min(1).max(200).optional(),
  uploadSha256: z.string().regex(/^[a-f0-9]{64}$/).optional(),
  uploadResumable: z.boolean().optional(),
  status: z.enum(["draft", "uploading", "paused", "ready", "failed"]),
  error: z.string().nullable(),
  origin: z.enum(["manual", "upload", "strategy_template"]).nullable().optional(),
  strategyId: z.string().max(80).nullable().optional(),
}).strict();

export const simulationV3DraftSchema = z.object({
  engineMode: engineModeSchema,
  audienceMarket: audienceMarketSchema,
  platform: platformSchema,
  outputLanguage: outputLanguageSchema,
  projectName: z.string().max(120),
  marketingBrief: z.string().max(12_000),
  sellingPoints: z.array(z.string().max(500)).max(10),
  audienceDescription: z.string().max(500),
  audienceAgeMin: z.string(),
  audienceAgeMax: z.string(),
  audienceGender: z.enum(["auto", "all", "female", "male"]),
  category: z.string().max(100),
  materials: z.array(composerMaterialSchema).max(20),
  placementBudget: z.number().finite().nonnegative(),
  productionBudget: z.number().finite().nonnegative(),
  creatorDistributionBudget: z.number().finite().nonnegative(),
  paidMediaBudget: z.number().finite().nonnegative(),
  campaignObjective: z.string().max(240),
  platformBudgets: z.object({
    tiktok: z.number().finite().nonnegative(),
    instagram: z.number().finite().nonnegative(),
    youtube: z.number().finite().nonnegative(),
    douyin: z.number().finite().nonnegative(),
    xhs: z.number().finite().nonnegative(),
    wechat_video: z.number().finite().nonnegative(),
  }).strict(),
  lifecycleDays: z.number().int().min(7).max(90),
  contentReport: z.record(z.unknown()).nullable(),
  randomSeed: z.number().int().nonnegative(),
  audienceFilters: z.record(z.unknown()).optional(),
  placementPlan: z.record(z.unknown()).nullable().optional(),
  parentTaskId: z.string().nullable().optional(),
  materialRevision: z.number().int().positive().optional(),
}).strict();
